/**
 * QR scaner
 * https://github.com/sembrestels/angular-qr-scanner
 */

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import grid from 'angular-ui-grid';
import routing from './main.routes';
import angularTreeControl from 'angular-tree-control';
import contextMenu from 'angular-tree-control/context-menu';
import module from '../module/module.component';
import journal from '../journal/journal.component';
import _document from '../document/document.component';
import alertMessages from '../../components/alert-messages/alert-messages';

import productDashboard from '../product-dashboard/product-dashboard.component';
import characteristicDashboard from '../characteristic-dashboard/characteristic-dashboard.component';
import storageDashboard from '../storage-dashboard/storage-dashboard.component';
import counterDashboard from '../counter-dashboard/counter-dashboard.component';

import categoryForm from '../category/category.component';

export class MainController {

  addWindow: Function;

  selectedModule;
  modules = [];

  categorySelected;
  categories;

  loadComplete;

  Storage;
  scope;


  /*@ngInject*/
  constructor($scope, $rootScope, Storage, WindowService, AlertMessageFactory) {
    this.Storage         = Storage;
    this.scope           = $scope;

    this.addWindow       = WindowService.addItem;

    $scope.$on('$destroy', function() {
      Storage.unbind();
    });

    this.error       = AlertMessageFactory.error;
    this.success     = AlertMessageFactory.success;

    this.treeOptions = {
      nodeChildren: "children",
      dirSelectable: true,
      isLeaf: (node) => false
    };

    this.loadComplete = false;

    $rootScope.$on('storage.save.category', (category) => {
      this.categories = this.buildCategoryTree();
    });
  }

  buildCategoryTree(parentId) {
    return this.Storage.getCategories()
      .filter(category => category.parentId == parentId && category.moduleId == this.getSelectedModuleId())
      .map(category => {
        category.children = this.buildCategoryTree(category._id) || [];

        return category;
      });
  }

  $onInit() {

    this.Storage.onUpdate('category', (category, event) => {
      this.categories = this.buildCategoryTree();
    });

    return this.Storage.load()
      .then(() => {

        this.modules = this.Storage.getModules();
        (this.modules || []).forEach(module => {
          if(module.default){
            this.onSelectModule(module);
          }
        });

        this.categories = this.buildCategoryTree();
        this.loadComplete = true;
      });
  }

  onCategorySelected(category) {
    this.categorySelected = category;

    if(this.elementsOfCategories){
      this.elementsOfCategories.categorySelected = this.categorySelected;

      if(this.elementsOfCategories.onCategoryChange){
        this.elementsOfCategories.onCategoryChange();
      }
    }
  }

  onSelectModule(module) {
    // reset selected category
    this.categorySelected     = undefined;
    // remember new module
    this.selectedModule       = module;
    // build tree of categories
    this.categories           = this.buildCategoryTree();
    // build module view
    this.elementsOfCategories = {
      component: module.resourceName.toLowerCase() + "-dashboard",
      module: module
    };
  }

  getSelectedModuleId() {
    if( ! this.selectedModule){
      return false;
    }

    return this.selectedModule._id;
  }

  search() {

  }

  addModule() {
    this.addWindow({
      id: 'create-module-window',
      component: 'module',
      title: 'Добавление модуля',
      width: 700,
      height: 530,
    });
  }

  addItem() {
    if( ! this.categorySelected){
      return this.error("Выберите категоррию!");
    }

    var component = this.selectedModule.resourceName.toLowerCase();

    this.addWindow({
      id: 'create-' + component + '-window',
      component: component,
      title: 'Форма ' + this.selectedModule.name,
      width: 700,
      height: 530,
      category: this.categorySelected,
      module: this.selectedModule,
    });
  }

  categoryForm(category) {
    this.addWindow({
      id: 'create-category-window',
      component: 'category',
      title: 'Форма категории',
      width: 700,
      height: 480,
      module: this.selectedModule,
      modules: this.modules,
      parent: this.categorySelected,
      category: category,
    });
  }

  addDocument(type) {
    this.addWindow({
      id: 'create-document-window',
      component: 'document',
      title: 'Создание документа',
      width: 900,
      height: 600,
      typeDocument: type
    });
  }

  journal() {
    this.addWindow({
      id: 'journal-documents-window',
      component: 'journal',
      title: 'Журнал документов',
      width: 900,
      height: 600
    });
  }
}

export default angular.module('storageApp.main', [
    uiRouter, 
    grid,
    grid + '.selection',
    grid + '.treeView',
    grid + '.cellNav',
    grid + '.edit',
    grid + '.rowEdit',
    grid + '.saveState',
    grid + '.grouping',

    module,
    journal,
    _document,
    alertMessages,
    angularTreeControl,
    productDashboard,
    characteristicDashboard,
    storageDashboard,
    counterDashboard,
    categoryForm,
  ])
  .config(routing)
  .component('main', {
    template: require('./main.html'),
    controller: MainController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js